var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelationships(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 56.086,
    viewBox: "0 0 53 56.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62757",
    "data-name": "Group 62757",
    transform: "translate(-0.072 -0.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60185",
    "data-name": "Ellipse 60185",
    transform: "translate(17.072 0.365)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60186",
    "data-name": "Ellipse 60186",
    transform: "translate(35.072 28.365)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60187",
    "data-name": "Ellipse 60187",
    transform: "translate(0.072 27.365)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107789",
    "data-name": "Path 107789",
    d: "M-818.389,7302.834a20.847,20.847,0,0,1,10.9-19.965",
    transform: "translate(822.862 -7275.222)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107791",
    "data-name": "Path 107791",
    d: "M.074,19.965A20.848,20.848,0,0,1,10.969,0",
    transform: "translate(19.787 55.122) rotate(-119)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107790",
    "data-name": "Path 107790",
    d: "M-807.568,7302.834a20.848,20.848,0,0,0-10.9-19.965",
    transform: "translate(854.814 -7275.222)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationships);
export default __webpack_public_path__ + "static/media/relationships.c142352d99d2a79ed1565446173d620d.svg";
export { ForwardRef as ReactComponent };